import { useEffect } from 'react';
import LegalPage from '@/components/LegalPage';
import { cookiePolicySV, cookiePolicyEN } from '@/data/legal/cookie-policy';

export default function CookiesPage() {
  useEffect(() => {
    document.title = 'Cookiepolicy - Beredskapshubben';
  }, []);

  return (
    <LegalPage 
      titleSV="Cookiepolicy"
      titleEN="Cookie Policy"
      contentSV={cookiePolicySV}
      contentEN={cookiePolicyEN}
    />
  );
}
